import { SVG, SVGProps } from './svg'

export function IconPalette(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m19.36 5.36-1.65-1.65A2.41 2.41 0 0 0 16 3a2 2 0 0 0-2 2v1.59a1 1 0 0 1-1.71.7l-.12-.12A4 4 0 0 0 9.34 6H8a6 6 0 0 0-6 6v1a8 8 0 0 0 8 8h4a8 8 0 0 0 8-8v-1.27a9 9 0 0 0-2.64-6.37ZM6.5 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM8 16.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm6.5 1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm1.5-5.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z"
      />
    </SVG>
  )
}
